import { useCallback } from "react";
import { useUserApiMutation } from "src/lib/filmwebid/useUserApiMutation";

type UseFavouriteArgs = {
	edi?: string | null;
	streamingId?: number | null;
	onComplete?: () => void;
}


export default function useFavourite({ edi, streamingId, onComplete }: UseFavouriteArgs): [(value: boolean) => void, boolean] {

	const { mutate, isPending } = useUserApiMutation("/api/Favourites", { allowAnon: false }, {
		onSuccess: onComplete,
	});
	const fn = useCallback((value: boolean) => {
		if (value) {
			mutate({
				method: "POST",
				body: {

					EDI: edi ?? null,
					streamingId: streamingId ?? null,
					source: window?.location?.hostname ?? null
				}
			});
		} else {
			mutate({
				method: "DELETE",
				params: {
					EDI: edi ?? null,
					streamingId: streamingId ?? null
				}
			});
		}
	}
		, [edi, mutate, streamingId]);
	return [fn, isPending];
}